"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var Api_1 = require("./Api");
var DeliveryInfoWLSProps_1 = require("../components/panels/DeliveryInfoWLS/DeliveryInfoWLSProps");
var Utils = require("../utils/UtilityFunctions");
var cartUtils = require("../utils/CartUtilFunctions");
var ReportingService_1 = require("./ReportingService");
var CheckoutConstants_1 = require("../utils/CheckoutConstants");
var Common = require("../utils/CommonUtilFuntions");
var ReportingHelperService = /** @class */ (function () {
    function ReportingHelperService() {
    }
    ReportingHelperService.prototype.constructFullUrl = function (path) {
        if (path.includes('http')) {
            return path;
        }
        return window.location.origin + path;
    };
    ReportingHelperService.prototype.getLinkPosition = function (linkNameValue, panelUrl, subPanelPos) {
        if (linkNameValue && linkNameValue.toLowerCase() === 'close') {
            return ReportingService_1.LinkPosition.BODY;
        }
        else {
            var linkPos = subPanelPos.reduce(function (pos, e) { return pos + "_" + e; }, "" + panelUrl.split('/').slice(-1));
            if (['modal', 'thankyou'].includes(linkPos.toLowerCase()) || subPanelPos.includes('body')) {
                return ReportingService_1.LinkPosition.BODY;
            }
            else if (linkPos.startsWith('modal_') || linkPos.startsWith('Modal_')) {
                return linkPos.replace('modal_', '').replace('Modal_', '').trim();
            }
            else {
                return linkPos;
            }
        }
    };
    /* istanbul ignore next */
    ReportingHelperService.prototype.getFormatedAdditionalDetailsCto = function (statusCode, statusMessage, linkDUrl, currentlinkName, errortype, status, successFlag, linkPos) {
        var finalErrortype = errortype ? errortype : ReportingService_1.ErrorTypeOption.Failure_System;
        var _statusMessage = statusMessage || 'UNKNOWN';
        var _statusCode = statusCode || '-2';
        var _successFlag = ReportingService_1.SuccessFlags.UNKNOWN;
        if (_statusCode === '0') {
            _successFlag = ReportingService_1.SuccessFlags.SUCCESSFUL;
            _statusMessage = 'SUCCESS';
        }
        else if (_statusCode === '-2') {
            _successFlag = ReportingService_1.SuccessFlags.UNKNOWN;
        }
        else {
            // if statusCode is not 0 or -2 then _successFlag will be 0 only
            _successFlag = ReportingService_1.SuccessFlags.UNSUCCESSFUL;
        }
        var linkPositionUrl = this.getLinkPosition(currentlinkName, linkDUrl, linkPos ? [linkPos] : []);
        return __assign(__assign(__assign(__assign({}, this.setErrorTypeBasedOnStatus(finalErrortype)), { linkDestinationUrl: (linkDUrl && linkDUrl.includes('/buy/checkout') &&
                !linkDUrl.includes('/modal')) ? '/buy/checkout/checkoutview' : linkDUrl, linkName: currentlinkName, linkPosition: linkPositionUrl, statusCode: _statusCode, statusMessage: _statusMessage, successFlag: _successFlag }), this.getFlowCodeAndproductType(linkDUrl)), this.getPromoCodes());
    };
    ReportingHelperService.prototype.getFormatedAdditionalDetails = function (isFailure, errorId, linkDUrl, currentlinkName, errortype, status, successFlag, linkPos) {
        var finalErrortype = (errorId === '-2') ? undefined : errortype ? errortype :
            ReportingService_1.ErrorTypeOption.Success_Admit;
        var finalStatusMessage = (errorId === '-2') ? 'UNKNOWN' : 'SUCCESS';
        var finalSuccessFlag = !Common.isEmpty(successFlag) ? successFlag : ReportingService_1.SuccessFlags.SUCCESSFUL;
        if (isFailure) {
            finalErrortype = errortype ? errortype : ReportingService_1.ErrorTypeOption.Failure_System;
            finalStatusMessage = status ? status : errorId;
            finalSuccessFlag = !Common.isEmpty(successFlag) ? successFlag : ReportingService_1.SuccessFlags.UNSUCCESSFUL;
        }
        var linkPositionUrl = this.getLinkPosition(currentlinkName, linkDUrl, linkPos ? [linkPos] : []);
        return __assign(__assign(__assign(__assign(__assign(__assign({}, this.setErrorTypeBasedOnStatus(finalErrortype)), { linkDestinationUrl: (linkDUrl && linkDUrl.includes('/buy/checkout') &&
                !linkDUrl.includes('/modal')) ? '/buy/checkout/checkoutview' : linkDUrl, linkName: currentlinkName, linkPosition: linkPositionUrl }), this.setStatusCodeBasedOnError(errorId)), { statusMessage: finalStatusMessage, successFlag: (finalStatusMessage === 'UNKNOWN') ? ReportingService_1.SuccessFlags.UNKNOWN : finalSuccessFlag }), this.getFlowCodeAndproductType(linkDUrl)), this.getPromoCodes());
    };
    ReportingHelperService.prototype.getFormatedAdditionalDtlsForDeliveryEvent = function (isFailure, errorId, linkDUrl, currentlineName, errorMsg, linkPos) {
        return __assign({}, this.getFormatedAdditionalDetails(isFailure, errorId, linkDUrl, currentlineName, (isFailure) ? ReportingService_1.ErrorTypeOption.Failure_System : ReportingService_1.ErrorTypeOption.Success_Admit, errorMsg, undefined, linkPos));
    };
    ReportingHelperService.prototype.getFormatedCKAVDetails = function (isFailure, errorId, currentlineName, linkDUrl, errorMsg) {
        return __assign(__assign({}, this.getCKAVSearchDetails()), this.getFormatedAdditionalDetails(isFailure, errorId, linkDUrl, currentlineName, (isFailure) ? ReportingService_1.ErrorTypeOption.Failure_System : ReportingService_1.ErrorTypeOption.Success_Admit, errorMsg));
    };
    ReportingHelperService.prototype.getFormattedPinValidationEventDetails = function (isFailure, errorId, linkDUrl, currentlineName, requestId, errorMsg) {
        return __assign({ mitigationIds: {
                category: 'Sales',
                code: Utils.getMitigationDetails() && Utils.getMitigationDetails().code,
            }, pinRequestId: requestId }, this.getFormatedAdditionalDetails(isFailure, errorId, linkDUrl, currentlineName, (isFailure) ? ReportingService_1.ErrorTypeOption.Failure_System : ReportingService_1.ErrorTypeOption.Success_Admit, errorMsg));
    };
    ReportingHelperService.prototype.getFormatedShippingDetailsInOrder = function (reportingData) {
        if (reportingData.shipping) {
            reportingData.shipping = this.getShippingMethodName(reportingData, reportingData.shipping);
        }
        if (reportingData.shippingDefault) {
            reportingData.shippingDefault = this.getShippingMethodName(reportingData, reportingData.shippingDefault);
        }
        return __assign({}, reportingData);
    };
    /*
     * All the flow code references are available in Wiki:
     * https://wiki.web.att.com/pages/viewpage.action?spaceKey=DETS&title=Product+Type+Instrumentation+Guide
     * And DTM reference here: https://wiki.web.att.com/display/DETS/Parameter+Definition+-+page.pageInfo.flowCode
     */
    /*
    * IMPORTANT: The order of the pushing flowcodes and productTypes is not to be changed as the final string should
    * follow the order mentioned in the WIKI page above. Any change to the order or the placement of any new products
    * should be confirmed with analytics team or PO.
    */
    ReportingHelperService.prototype.getFlowCodeAndproductType = function (urlVal, displayedMessage) {
        var orderSubType = Utils.getCurrentFlowType();
        orderSubType = orderSubType ? orderSubType.toUpperCase() : undefined;
        var flowCodeArr = [];
        var productTypeArr = [];
        var lineOfBusiness = 'General';
        var isfirstNetCaribbean = Utils.isFirstNetCaribbean() ? 'Caribbean' : 'Pacific';
        if (orderSubType && typeof orderSubType === 'string') {
            /*
                Wireline LOBs
            */
            if (orderSubType.includes('NEW_DTVS')) {
                if (!flowCodeArr.includes(CheckoutConstants_1.lineItemFlowCodes.WIRELINE_COMMON)) {
                    flowCodeArr.push(CheckoutConstants_1.lineItemFlowCodes.WIRELINE_COMMON);
                }
                productTypeArr.push('DTV');
                lineOfBusiness = 'Wireline';
            }
            if (orderSubType.includes('NEW_IPTV')) {
                if (!flowCodeArr.includes(CheckoutConstants_1.lineItemFlowCodes.WIRELINE_COMMON)) {
                    flowCodeArr.push(CheckoutConstants_1.lineItemFlowCodes.WIRELINE_COMMON);
                }
                productTypeArr.push('IPTV');
                lineOfBusiness = 'Wireline';
            }
            if ((orderSubType.includes('NEW_DTVNOW') || orderSubType.includes('EXISTING_DTVNOW_NEW_BROADBAND'))
                && Utils.getMigrationSource()) {
                if (!flowCodeArr.includes(CheckoutConstants_1.lineItemFlowCodes.WIRELINE_IPTVMIGRATION)) {
                    flowCodeArr.push(CheckoutConstants_1.lineItemFlowCodes.WIRELINE_IPTVMIGRATION);
                }
                lineOfBusiness = 'Wireline';
            }
            else if (orderSubType.includes('NEW_DTVNOW') && (Utils.IsBBTVInCart() || cartUtils.IsEDSPFlow())) {
                if (!flowCodeArr.includes(CheckoutConstants_1.lineItemFlowCodes.WIRELINE_COMMON)) {
                    flowCodeArr.push(CheckoutConstants_1.lineItemFlowCodes.WIRELINE_COMMON);
                }
                lineOfBusiness = 'Wireline';
            }
            if ((orderSubType.includes('NEW_BROADBAND') || orderSubType.includes('EXISTING_DTVNOW_NEW_BROADBAND'))
                && !Utils.getMigrationSource()) {
                if (!flowCodeArr.includes(CheckoutConstants_1.lineItemFlowCodes.WIRELINE_COMMON)) {
                    flowCodeArr.push(CheckoutConstants_1.lineItemFlowCodes.WIRELINE_COMMON);
                }
                if (cartUtils.getIsGigaInCart()) {
                    productTypeArr.push('Fiber Broadband');
                }
                else {
                    productTypeArr.push('Copper Broadband');
                }
                lineOfBusiness = 'Wireline';
            }
            if (orderSubType.includes('NEW_VOIP')) {
                if (!flowCodeArr.includes(CheckoutConstants_1.lineItemFlowCodes.WIRELINE_COMMON)) {
                    flowCodeArr.push(CheckoutConstants_1.lineItemFlowCodes.WIRELINE_COMMON);
                }
                productTypeArr.push('Wireline Phone');
                lineOfBusiness = 'Wireline';
            }
            /*
                Postpaid Wireless LOBs
            */
            var eapContext = cartUtils.getEAPDetails();
            var byodFlowCheck = cartUtils.isBYODFlow();
            if (orderSubType.includes('WIRELESS') && (!eapContext.isEAPFlow || (eapContext === null || eapContext === void 0 ? void 0 : eapContext.simType) === 'eSIM')) {
                if (orderSubType.includes('NEW_WIRELESS')) {
                    if (Utils.isAccessoryOnlyInCart()) {
                        if (!flowCodeArr.includes(CheckoutConstants_1.lineItemFlowCodes.ACCESSORY)) {
                            flowCodeArr.push(CheckoutConstants_1.lineItemFlowCodes.ACCESSORY);
                        }
                    }
                    else if (!flowCodeArr.includes(CheckoutConstants_1.lineItemFlowCodes.WIRELESS_NEW)) {
                        flowCodeArr.push(CheckoutConstants_1.lineItemFlowCodes.WIRELESS_NEW);
                    }
                }
                if (orderSubType.includes('AAL_WIRELESS') || orderSubType.includes('UP_AL_WIRELESS')) {
                    if (!flowCodeArr.includes(CheckoutConstants_1.lineItemFlowCodes.WIRELESS_AAL)) {
                        flowCodeArr.push(CheckoutConstants_1.lineItemFlowCodes.WIRELESS_AAL);
                    }
                }
                if (orderSubType.includes('UPGRADE_WIRELESS') || orderSubType.includes('UP_AL_WIRELESS')) {
                    if (!flowCodeArr.includes(CheckoutConstants_1.lineItemFlowCodes.WIRELESS_UPGRADE)) {
                        flowCodeArr.push(CheckoutConstants_1.lineItemFlowCodes.WIRELESS_UPGRADE);
                    }
                }
                if (byodFlowCheck.isMixedFlowWithBYOD) {
                    productTypeArr.push('Postpaid|Postpaid BYOD');
                }
                else if (byodFlowCheck.isBYODFlow) {
                    productTypeArr.push('Postpaid BYOD');
                }
                else if (Utils.isAccessoryOnlyInCart()) {
                    productTypeArr.push('ACCESSORY');
                }
                else if (Utils.showOnDeviceWearablePPU()) {
                    if (Utils.isAppleDevice()) {
                        productTypeArr.push('EAP Postpaid Wearable Apple');
                    }
                    else {
                        productTypeArr.push('EAP Postpaid Wearable Android');
                    }
                }
                else if (Utils.isAIABFlow()) {
                    productTypeArr.push('Wireless Broadband');
                }
                else {
                    !Utils.isConnectedCarFlow() && productTypeArr.push('Postpaid');
                }
            }
            /*
                EAP LOB
            */
            if (eapContext.isEAPFlow && !((eapContext === null || eapContext === void 0 ? void 0 : eapContext.simType) === 'eSIM')) {
                if (eapContext.eapFlowType === 'NEW_EAP' || eapContext.eapFlowType === 'NEW_EAP_ON') {
                    if (!flowCodeArr.includes(CheckoutConstants_1.lineItemFlowCodes.EAP_NEW)) {
                        flowCodeArr.push(CheckoutConstants_1.lineItemFlowCodes.EAP_NEW);
                    }
                    if (Utils.showOnDeviceWearablePPU()) {
                        if (Utils.isAppleDevice()) {
                            productTypeArr.push('EAP Postpaid Wearable Apple');
                        }
                        else {
                            productTypeArr.push('EAP Postpaid Wearable Android');
                        }
                    }
                    else if (eapContext.eapFlowType === 'NEW_EAP_ON') {
                        productTypeArr.push('EAP Postpaid On Device');
                    }
                    else {
                        productTypeArr.push('EAP Postpaid Coam');
                    }
                }
                if (eapContext.eapFlowType === 'AAL_EAP' || eapContext.eapFlowType === 'AAL_EAP_ON') {
                    if (!flowCodeArr.includes(CheckoutConstants_1.lineItemFlowCodes.EAP_AAL)) {
                        flowCodeArr.push(CheckoutConstants_1.lineItemFlowCodes.EAP_AAL);
                    }
                    if (Utils.isConnectedCarFlow()) {
                        productTypeArr.push('EAP Postpaid Connected Car');
                    }
                    else if (Utils.showOnDeviceWearablePPU()) {
                        if (Utils.isAppleDevice()) {
                            productTypeArr.push('EAP Postpaid Wearable Apple');
                        }
                        else {
                            productTypeArr.push('EAP Postpaid Wearable Android');
                        }
                    }
                    else if (eapContext.eapFlowType === 'AAL_EAP_ON') {
                        productTypeArr.push('EAP Postpaid On Device');
                    }
                    else {
                        productTypeArr.push('EAP Postpaid Coam');
                    }
                }
            }
            /*
                Prepaid Wireless LOBs
            */
            if (orderSubType.includes('PREPAID')) {
                if (!flowCodeArr.includes(CheckoutConstants_1.lineItemFlowCodes.WIRELESS_PREPAID)) {
                    flowCodeArr.push(CheckoutConstants_1.lineItemFlowCodes.WIRELESS_PREPAID);
                }
                if (byodFlowCheck.isMixedFlowWithBYOD) {
                    productTypeArr.push('Prepaid|Prepaid BYOD');
                }
                else if (byodFlowCheck.isBYODFlow) {
                    productTypeArr.push('Prepaid BYOD');
                }
                else {
                    productTypeArr.push('Prepaid');
                }
            }
            /*
                DTVNow LOBs
            */
            if (orderSubType.includes('NEW_DTVNOW') || orderSubType.includes('EXISTING_BROADBAND_NEW_DTVNOW')) {
                if (!flowCodeArr.includes(CheckoutConstants_1.lineItemFlowCodes.WIRELINE_DTVNOW) && !Utils.IsBBTVInCart() &&
                    !cartUtils.IsEDSPFlow()) {
                    flowCodeArr.push(CheckoutConstants_1.lineItemFlowCodes.WIRELINE_DTVNOW);
                }
                var pType = (cartUtils.IsEDSPFlow()) ? 'ATTTVEDSP' : Utils.IsBBTVInCart() ? 'ATTTV' : 'DTVNow';
                productTypeArr.push(pType);
                lineOfBusiness = 'Wireline';
            }
        }
        if (flowCodeArr.length === 0) {
            flowCodeArr.push(CheckoutConstants_1.lineItemFlowCodes.UNKNOWN);
        }
        return __assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign({}, (Utils.isFirstNetFlow() ? ({ 'page.attributes.firstNetGeolocation': isfirstNetCaribbean }) : {})), (displayedMessage ? ({ 'page.attributes.displayedMessage': displayedMessage }) : {})), { 'page.attributes.productType': productTypeArr.join('|'), 'page.pageInfo.flowCode': flowCodeArr.join('|'), 'page.pageInfo.lineOfBusiness': lineOfBusiness }), ((Utils === null || Utils === void 0 ? void 0 : Utils.IsBsseFlow()) ? ({ 'page.attributes.billingSytem': 'R' }) : {})), this.getUserAccountInfo()), this.getReconnectParams()), this.getPageAdditionalInfo(urlVal)), (urlVal === ReportingService_1.PageUrls.ACCOUNT_INFO_SUB_PAGE && this.getPromoCodes()));
    };
    ReportingHelperService.prototype.getRetrievedCartFlag = function () {
        var cartRetFlag = '-2';
        var pageUrl = window.location.href;
        if (pageUrl.includes('sharedCart=true')) {
            cartRetFlag = '1';
        }
        else if (pageUrl.includes('retrieveCart=true')) {
            cartRetFlag = '0';
        }
        if (cartRetFlag !== '-2') {
            return {
                cartRetrievedFlag: cartRetFlag,
            };
        }
        else {
            return {};
        }
    };
    ReportingHelperService.prototype.getUserAccountInfo = function () {
        var payload = Utils.getCartResp();
        var isSMBCustomer = cartUtils.isSMBCustomer();
        var liabilityType = 'CONS';
        var b2bDetail = payload && (payload === null || payload === void 0 ? void 0 : payload.b2bDetail);
        if (b2bDetail && isSMBCustomer) {
            liabilityType = 'CRU';
        }
        else if (b2bDetail && !isSMBCustomer) {
            liabilityType = 'IRU';
        }
        liabilityType = Utils.isSMBBBCustomerFlow() ? 'CRU' : liabilityType;
        var userAccountInfoObj = {
            'user.account.liabilityType': liabilityType,
            'user.customerType': isSMBCustomer ? 'SMB' : Utils.IsEmployeeOfferAvailable() ? 'EMP' : 'CONS',
            'user.firstNetFlag': Utils.isFirstNetFlow() ? 1 : 0,
        };
        var fandetails = {
            'user.account.fan': (b2bDetail && b2bDetail.FAN) ? b2bDetail.FAN : '',
        };
        if (Utils.isAuthuser()) {
            return __assign(__assign(__assign({}, userAccountInfoObj), fandetails), { 'user.login.userType': isSMBCustomer ? 'SMB' : 'CONS' });
        }
        else if (isSMBCustomer) {
            return __assign(__assign({}, userAccountInfoObj), fandetails);
        }
        return userAccountInfoObj;
    };
    ReportingHelperService.prototype.getReconnectParams = function () {
        var isReconnectFlag = Utils.checkBusinessType(CheckoutConstants_1.offerTypeCodes.RECONNECT);
        var isAquisitionFlag = Utils.checkBusinessType(CheckoutConstants_1.offerTypeCodes.ACQUISITION);
        if (isReconnectFlag) {
            return {
                'page.attributes.reconnectIndicator': 1,
                'page.attributes.reconnectOfferType': 'Reconnect',
            };
        }
        else if (isAquisitionFlag) {
            return {
                'page.attributes.reconnectIndicator': 0,
                'page.attributes.reconnectOfferType': 'Acquisition',
            };
        }
        else {
            return {
                'page.attributes.reconnectIndicator': 0,
            };
        }
    };
    ReportingHelperService.prototype.getPageAdditionalInfo = function (urlVal) {
        var _a, _b;
        var getViewedUIExperience = window && (window.innerWidth < 768 ? 'Smartphone' : window.innerWidth < 1025 ?
            'Tablet' : 'Desktop');
        var localizationCookie = Utils.getCookie('attPersistantLocalization');
        var zipCode = localizationCookie && (this.getCookieData(localizationCookie, 'zipCode') ?
            this.getCookieData(localizationCookie, 'zipCode') : this.getCookieData(localizationCookie, 'zip'));
        return {
            'page.category.applicationName': 'Digital Sales',
            'page.category.pageFunction': 'Sales',
            'page.category.pageOwnership': 'Consumer',
            'page.category.siteSection': 'myATT Sales',
            'page.location.url': (urlVal === null || urlVal === void 0 ? void 0 : urlVal.includes('/thankyou')) ? '' : urlVal,
            'page.pageInfo.friendlyPageName': ReportingService_1.notifyFriendlyName[urlVal],
            'page.pageInfo.language': ((_b = (_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.href) === null || _b === void 0 ? void 0 : _b.indexOf('es-us')) > -1 ? 'ES' : 'EN',
            'page.pageInfo.responsiveWebDesignFlag': '1',
            'page.pageInfo.viewedUIExperience': getViewedUIExperience,
            'page.pageInfo.zipCode': zipCode,
            'user.uuid': Utils.getCookie('UUID'),
        };
    };
    ReportingHelperService.prototype.getCookieData = function (cookieData, key) {
        var _a, _b, _c;
        var dataVal = '';
        if (cookieData.indexOf('|') > -1) {
            dataVal = (_b = (_a = cookieData === null || cookieData === void 0 ? void 0 : cookieData.split(key + '=')) === null || _a === void 0 ? void 0 : _a[1]) === null || _b === void 0 ? void 0 : _b.split('|')[0];
        }
        else {
            dataVal = (_c = cookieData.split(key + '=')) === null || _c === void 0 ? void 0 : _c[1];
        }
        return dataVal;
    };
    ReportingHelperService.prototype.additionalPageLoadData = function (pageTrigger, urlVal, displayedMessage) {
        var additionalPageLoadData = this.getFlowCodeAndproductType(urlVal, displayedMessage);
        if (pageTrigger) {
            additionalPageLoadData = __assign(__assign({}, additionalPageLoadData), { pageTriggerMethod: pageTrigger });
        }
        return additionalPageLoadData;
    };
    ReportingHelperService.prototype.getScheduleInstallData = function (displayedMessage, dtvCalendarPreferenceFlag, calendarPreferenceFlag, dtvInstallDate, dtvInstallTime, installTime, installDate, dualCalenderDisplayFlag, singleDispatchFlag) {
        return __assign({ calendarPreferenceFlag: calendarPreferenceFlag,
            displayedMessage: displayedMessage,
            dtvCalendarPreferenceFlag: dtvCalendarPreferenceFlag,
            dtvInstallDate: dtvInstallDate,
            dtvInstallTime: dtvInstallTime,
            dualCalenderDisplayFlag: dualCalenderDisplayFlag,
            installDate: installDate,
            installTime: installTime,
            singleDispatchFlag: singleDispatchFlag }, this.getFormatedAdditionalDetails(false, '0', this.constructFullUrl(ReportingService_1.PageUrls.SCHEDULE_INSTALATION_PANEL), ''));
    };
    ReportingHelperService.prototype.getFormattedInsuranceDetails = function (insuranceData) {
        var _a, _b;
        var insuranceList = [];
        if (Utils.isUPFlow()) {
            if (insuranceData === null || insuranceData === void 0 ? void 0 : insuranceData.isAccLevelInsurance) {
                var accountLevelItem = {
                    itemCategory: 'Insurance',
                    itemHierarchy: 'Account Level',
                    itemName: (_a = insuranceData === null || insuranceData === void 0 ? void 0 : insuranceData.accLevelInsuranceDetails) === null || _a === void 0 ? void 0 : _a.displayName,
                    itemQty: 1,
                    itemSku: (_b = insuranceData === null || insuranceData === void 0 ? void 0 : insuranceData.accLevelInsuranceDetails) === null || _b === void 0 ? void 0 : _b.skuId,
                };
                insuranceList.push(accountLevelItem);
            }
            if (insuranceData === null || insuranceData === void 0 ? void 0 : insuranceData.subscriberFeatures) {
                var subscriberIds = Object.keys(insuranceData.subscriberFeatures);
                // tslint:disable-next-line: no-any
                subscriberIds.forEach(function (id) {
                    var subscriberItem = insuranceData.subscriberFeatures[id];
                    if ((subscriberItem === null || subscriberItem === void 0 ? void 0 : subscriberItem.subscriberNumber) === Common.getSubscriberNumber() && (subscriberItem === null || subscriberItem === void 0 ? void 0 : subscriberItem.isInsurance)) {
                        var subscriberLevelItem = {
                            itemCategory: 'Insurance',
                            itemHierarchy: 'Subscriber Level',
                            itemName: subscriberItem === null || subscriberItem === void 0 ? void 0 : subscriberItem.displayName,
                            itemQty: 1,
                            itemSku: subscriberItem === null || subscriberItem === void 0 ? void 0 : subscriberItem.skuId,
                            itemSocCode: subscriberItem === null || subscriberItem === void 0 ? void 0 : subscriberItem.insuranceBillCode,
                        };
                        insuranceList.push(subscriberLevelItem);
                    }
                });
            }
            var formattedExistingPlanDetails = cartUtils.getExistingPlanName();
            if (formattedExistingPlanDetails) {
                insuranceList.push(formattedExistingPlanDetails);
            }
        }
        return {
            existingItems: insuranceList,
        };
    };
    ReportingHelperService.prototype.reportingGetPoeDetails = function (errorInResponse) {
        var currentFlowType = Utils.getOrderSubType();
        var details = Common.mapB2bPoeDetails();
        if (details && details.fan) {
            var fanVerifyArry = {
                customerSegment: details === null || details === void 0 ? void 0 : details.segment,
                sheerResponseMessage: errorInResponse ? 'Error' : details === null || details === void 0 ? void 0 : details.verificationStatus,
                sheerResponseTime: '',
                sheerVerificationId: details === null || details === void 0 ? void 0 : details.verificationId,
            };
            var poeDetailsObj = {
                customerBranchType: details === null || details === void 0 ? void 0 : details.branchType,
                customerMilitaryStatus: '',
                customerFan: details === null || details === void 0 ? void 0 : details.fan,
                docUploadCount: details === null || details === void 0 ? void 0 : details.docUploadCount,
                existingWirelessCustomerFlag: (currentFlowType === null || currentFlowType === void 0 ? void 0 : currentFlowType.indexOf('NEW_WIRELESS')) !== -1 ? '0' : '1',
                fanVerifications: [fanVerifyArry],
            };
            return poeDetailsObj;
        }
        else {
            return null;
        }
    };
    ReportingHelperService.prototype.getCartItemDetails = function (submitAction) {
        if (submitAction === ReportingService_1.EventActions.FORM_RESPONSE || submitAction === ReportingService_1.EventActions.SYSTEM_EVENT) {
            var CartInfoApiData = JSON.parse(sessionStorage.getItem('CART:cartInfo'));
            var modifiedCartDetails = this.modifyCartData(CartInfoApiData);
            return modifiedCartDetails;
        }
    };
    // tslint:disable-next-line: no-any
    ReportingHelperService.prototype.modifyCartData = function (cartObj) {
        if (cartObj && !cartObj.items && cartObj.cartItems) {
            cartObj.items = cartObj.cartItems;
            delete cartObj.cartItems;
        }
        return cartObj;
    };
    ReportingHelperService.prototype.isAccountLock = function () {
        var _a, _b;
        if ((Utils === null || Utils === void 0 ? void 0 : Utils.isAuthuser()) && ((_a = Utils === null || Utils === void 0 ? void 0 : Utils.getOrderSubType()) === null || _a === void 0 ? void 0 : _a.includes('WIRELESS'))) {
            return {
                wirelessAccountLockedFlag: ((_b = Utils === null || Utils === void 0 ? void 0 : Utils.getCartResp()) === null || _b === void 0 ? void 0 : _b.isAccountLocked) ? 1 : 0,
            };
        }
    };
    ReportingHelperService.prototype.getShippingMethodName = function (reportingData, parameter) {
        var requiredFormattedName = '';
        switch (parameter) {
            case DeliveryInfoWLSProps_1.ShippingMethodTypes.SDDP:
            case DeliveryInfoWLSProps_1.ShippingMethodTypes.SDD:
                requiredFormattedName = 'dropOff';
                break;
            case DeliveryInfoWLSProps_1.ShippingMethodTypes.EXPRESS_SHIPPING:
                requiredFormattedName = 'Express';
                break;
            case DeliveryInfoWLSProps_1.ShippingMethodTypes.STORE_PICKUP:
                requiredFormattedName = 'In-Store Pickup';
                break;
            case DeliveryInfoWLSProps_1.ShippingMethodTypes.STANDARD_SHIPPING:
            case DeliveryInfoWLSProps_1.ShippingMethodTypes.STANDARD:
                requiredFormattedName = 'Standard';
                break;
            case DeliveryInfoWLSProps_1.ShippingMethodTypes.IHX:
                requiredFormattedName = 'In-Home Expert';
                break;
            case 'freeship':
                requiredFormattedName = 'Free';
                break;
        }
        return requiredFormattedName;
    };
    ReportingHelperService.prototype.getCKAVSearchDetails = function () {
        this.api = new Api_1.default();
        var ckavStatus = this.api.getCkavStorageData();
        return {
            addressType: 'residential',
            connectedComm: (ckavStatus && ckavStatus.availableServices &&
                ckavStatus.availableServices.connectedCommunity),
            dtvAvailResult: (ckavStatus && ckavStatus.availableServices &&
                ckavStatus.availableServices.dtvAvailable),
            dtvConnectedComm: (ckavStatus && ckavStatus.availableServices &&
                ckavStatus.availableServices.connectedCommunity),
            dtvIneligibleReason: this.getDtvIneligibleReason(ckavStatus &&
                ckavStatus.dtvAttributes, ckavStatus && ckavStatus.availabilityStatus),
            dwellingType: this.getDwellingType(ckavStatus &&
                ckavStatus.dtvAttributes, ckavStatus && ckavStatus.availabilityStatus),
            eligResult: !!(ckavStatus && ckavStatus.addressFeatures &&
                ckavStatus.addressFeatures.addressId) ? 'System' : 'User entered',
            eluid: (ckavStatus && ckavStatus.addressFeatures &&
                ckavStatus.addressFeatures.addressId),
            existingServiceSummary: this.getAvailableServices(ckavStatus && ckavStatus.existingServices),
            gigaAvailResult: (ckavStatus && ckavStatus.availableServices &&
                ckavStatus.availableServices.lightSpeedAvailable),
            hsiaAvailResult: (ckavStatus && ckavStatus.availableServices &&
                ckavStatus.availableServices.hsiaAvailable),
            iptvAvailResult: (ckavStatus && ckavStatus.availableServices &&
                ckavStatus.availableServices.iptvAvailable),
            offerId: !!(ckavStatus && ckavStatus.privateOfferEligible) ? 'Yes' : 'No',
            qualCriteria: !!(ckavStatus && ckavStatus.addressFeatures &&
                ckavStatus.addressFeatures.addressId) ? 'AddressID' : 'NA',
            sysRespCode: (ckavStatus && ckavStatus.addressFeatures &&
                ckavStatus.addressFeatures.wireCenterCode),
            sysTransId: (ckavStatus && ckavStatus.addressFeatures &&
                ckavStatus.addressFeatures.wireCenterCode),
            userResp: 'Direct TV',
            uverseFootprintFlag: (ckavStatus && ckavStatus.addressFeatures &&
                ckavStatus.addressFeatures.zip),
            uverseTransportType: !!(ckavStatus && ckavStatus.availableServices &&
                ckavStatus.availableServices.hsiaAvailable) ? 'HISA' : 'NA',
            voipAvailResult: (ckavStatus && ckavStatus.availableServices &&
                ckavStatus.availableServices.voipAvailable),
            wirelessAvailResult: (ckavStatus && ckavStatus.availableServices &&
                ckavStatus.availableServices.wirelessAvailable),
        };
    };
    ReportingHelperService.prototype.getDtvIneligibleReason = function (dTVAttributes, availabilityStatus) {
        if (dTVAttributes && dTVAttributes.d2liteCustomer) {
            return 'D2 Lite';
        }
        else if (dTVAttributes && dTVAttributes.directTVConnectedProperty) {
            return 'Direct TV Connected Property';
        }
        else if (dTVAttributes && dTVAttributes.permanentLOS) {
            return 'Permanent LOS';
        }
        else if (dTVAttributes && dTVAttributes.tempLOS) {
            return 'Temp LOS';
        }
        else if (dTVAttributes && dTVAttributes.restrictedDelearAddress) {
            return 'Restricted Delear Address';
        }
        else if (availabilityStatus === 'RED') {
            return 'Restricted address';
        }
        else if (availabilityStatus === 'CLOSEMATCH') {
            return 'Multiple matches found';
        }
        else if (availabilityStatus === 'NOMATCH') {
            return 'No address found';
        }
        else if (availabilityStatus === 'EXISTINGSERVICESFOUND') {
            return 'Exiting service found';
        }
        else if (availabilityStatus === 'MDU') {
            return 'Unit number missing';
        }
        else {
            return 'NA';
        }
    };
    ReportingHelperService.prototype.getDwellingType = function (dTVAttributes, availabilityStatus) {
        if (dTVAttributes && dTVAttributes.d2liteCustomer) {
            return 'DTV MDU D2Lite';
        }
        else if (dTVAttributes && dTVAttributes.directTVConnectedProperty) {
            return 'DTV MDU Connected Property';
        }
        else if (dTVAttributes && dTVAttributes.permanentLOS) {
            return 'DTV MDU Dealer Restricted Bulk';
        }
        else if (dTVAttributes && (dTVAttributes.tempLOS || dTVAttributes.restrictedDelearAddress)) {
            return 'DTV MDU Dealer Restricted DTH';
        }
        else if (availabilityStatus === 'MDU') {
            return 'MDU';
        }
        else {
            return 'Other';
        }
    };
    ReportingHelperService.prototype.getAvailableServices = function (availableServices) {
        var existingServices = '';
        if (availableServices && availableServices.dtvServiceExisting) {
            existingServices = existingServices + '~DTV~';
        }
        if (availableServices && availableServices.wirelessServiceExisting) {
            existingServices = existingServices + '~Wireless~';
        }
        if (availableServices && availableServices.uverseServiceExisting) {
            existingServices = existingServices + '~U-verse~';
        }
        if (availableServices && availableServices.dslServiceExisting) {
            existingServices = existingServices + '~DSL~';
        }
        if (availableServices && availableServices.wirelineServiceExisting) {
            existingServices = existingServices + '~Wireline~';
        }
        if (availableServices && availableServices.telcoServiceExisting) {
            existingServices = existingServices + '~WLHP~';
        }
        if (availableServices && availableServices.wllServiceExisting) {
            existingServices = existingServices + '~WLL~';
        }
        if (existingServices === '') {
            existingServices = 'NA';
        }
        return existingServices;
    };
    ReportingHelperService.prototype.setStatusCodeBasedOnError = function (errorId) {
        if (errorId) {
            return {
                statusCode: errorId,
            };
        }
        else {
            return {};
        }
    };
    ReportingHelperService.prototype.setErrorTypeBasedOnStatus = function (errorType) {
        if (errorType) {
            return {
                errorType: errorType,
            };
        }
        else {
            return {};
        }
    };
    ReportingHelperService.prototype.getPromoCodes = function () {
        var _a, _b;
        var orderSubType = Utils.getOrderSubType();
        orderSubType = orderSubType ? orderSubType.toUpperCase() : undefined;
        var payload = Utils.getCartResp();
        var promoCodesStr = '';
        if (orderSubType && typeof orderSubType === 'string') {
            if (orderSubType.includes('NEW_BROADBAND')) {
                promoCodesStr = (_b = (_a = payload === null || payload === void 0 ? void 0 : payload.broadbandCart) === null || _a === void 0 ? void 0 : _a.promotions) === null || _b === void 0 ? void 0 : _b.map(function (promotion) {
                    if (promotion === null || promotion === void 0 ? void 0 : promotion.couponCode) {
                        return promotion.couponCode;
                    }
                    else if (promotion === null || promotion === void 0 ? void 0 : promotion.promotionCode) {
                        return promotion === null || promotion === void 0 ? void 0 : promotion.promotionCode;
                    }
                }).filter(function (promocode) { return promocode; }).join('|');
            }
        }
        return {
            promoCode: promoCodesStr,
        };
    };
    return ReportingHelperService;
}());
exports.default = ReportingHelperService;
//# sourceMappingURL=ReportingHelperService.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/checkout-ui/api/ReportingHelperService.js
// module id = 1974
// module chunks = 8